<template>
  <div class="example-container">
    <div class="example-ui" v-if="hasExample">
      <div>
        <slot name="ui-example" />
      </div>
    </div>
    <div class="example-code" :class="{'no-example': !hasExample}">
      <pre class="code-sample"><code class="html"><slot name="code-example" /></code></pre>
    </div>
    <div class="example-link">
      <slot name="link" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentExample",
  computed: {
    hasExample() {
      return !!this.$slots["ui-example"];
    }
  }
};
</script>

/* eslint-disable */
<style lang="sass?outputStyle=expanded">
  .example-code {
    pre {
      code {
        font-size: .875rem;
      }
    }
  }
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/ComponentExample.vue